import { Component, Inject, PLATFORM_ID, ViewEncapsulation } from '@angular/core';
import { RouterModule } from '@angular/router';
import { AuthService } from '@coreApiServices';
import { SubscribersService } from '@coreServices';
import { CommonConstants, ROUTES } from '@coreConstant';
import { NgbModal, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { Subject, takeUntil } from 'rxjs';
import { HandleImageErrorDirective } from 'src/app/core/directives/handle-image-error.directive';
import { isPlatformBrowser } from "@angular/common";

@Component({
  selector: 'app-footer',
  standalone: true,
  imports: [RouterModule, HandleImageErrorDirective, NgbTooltipModule],
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'], // corrected the typo here (styleUrl -> styleUrls)
  encapsulation: ViewEncapsulation.None
})
export class FooterComponent {
  currentYear: number = new Date().getFullYear();
  public isUserAuthenticated: boolean = true;
  protected readonly s3BucketUrl = CommonConstants.IMAGE_KIT_ENDPOINT;
  productDetailClass = '';
  destroy$ = new Subject<void>();
  ROUTES = ROUTES;
  protected readonly isPlatformBrowser = isPlatformBrowser;
  socialLinks = [
    { label: 'Facebook', url: CommonConstants.SOCIAL_MEDIA_URLS.FACEBOOK, iconPath: '/ASSETS/GENERAL/ICONS/facebook-icon-white.svg' },
    { label: 'Instagram', url: CommonConstants.SOCIAL_MEDIA_URLS.INSTAGRAM, iconPath: '/ASSETS/GENERAL/ICONS/instagram-icon-white.svg' },
    { label: 'Pinterest', url: CommonConstants.SOCIAL_MEDIA_URLS.PINTEREST, iconPath: '/ASSETS/GENERAL/ICONS/pinterest-icon-white.svg' },
    { label: 'Youtube', url: CommonConstants.SOCIAL_MEDIA_URLS.YOUTUBE, iconPath: '/ASSETS/GENERAL/ICONS/youtube-icon-white.svg' },
  ];
  footerMenus = [
    {
      title: 'About',
      items: [
        { label: 'Our Story', route: ROUTES.OUR_STORY },
        { label: 'Gather Commitment', route: ROUTES.GATHER_COMMITMENT },
        { label: 'Tiles for Smiles', route: ROUTES.TILES_FOR_SMILES },
        { label: 'Projects', route: ROUTES.FEATURE_PROJECTS.ROOT },
        { label: 'Blogs', route: ROUTES.BLOGS.ROOT },
      ],
    },
    {
      title: 'Products',
      items: [
        { label: 'Flooring', route: ROUTES.FLOORING.ROOT },
        { label: 'Walling', route: ROUTES.WALLING.ROOT },
        { label: 'Outlet', route: ROUTES.OUTLET.ROOT },
      ],
    },
    {
      title: 'Support',
      items: [
        { label: 'Resource Hub', route: ROUTES.RESOURCE_HUB },
        { label: 'Price List', route: ROUTES.PRICE_LIST, conditional: true, tooltip: CommonConstants.PRICE_MENU_TOOLTIP_MESSAGE },
        { label: 'FAQ', route: ROUTES.FAQ },
        { label: 'Contact', route: ROUTES.CONTACT },
      ],
    },
  ];
  paymentLogos = [
    { path: '/ASSETS/GENERAL/LOGO/pay-advantage-icon-white.svg', alt: 'Pay Advantage', width: 106, height: 22 },
    { path: '/ASSETS/GENERAL/LOGO/b-pay-icon-white.svg', alt: 'BPAY', width: 50, height: 22 },
    { path: '/ASSETS/GENERAL/LOGO/visa-icon-white.svg', alt: 'VISA', width: 44, height: 15 },
    { path: '/ASSETS/GENERAL/LOGO/master-card-icon-white.svg', alt: 'MasterCard', width: 35, height: 22 },
    { path: '/ASSETS/GENERAL/LOGO/american-express-icon-white.svg', alt: 'American Express', width: 38, height: 25 },
  ];

  constructor(
    private authService: AuthService,
    private subscriberService: SubscribersService,
    private ngbModal: NgbModal,
    @Inject(PLATFORM_ID) protected platformId: any,
  ) {
    this.isUserAuthenticated = this.authService.isUserAuthenticated();
    this.subscriberService.isUserLoggedIn.pipe(takeUntil(this.destroy$)).subscribe((options) => {
      this.isUserAuthenticated = options;
    });
  }

  ngOnInit() {
    this.subscriberService.isProductDetailPageSubject.pipe(takeUntil(this.destroy$)).subscribe((res) => {
      this.productDetailClass = res ? 'copyright-section-custom' : '';
    })
  }

  async openSignUpModal() {
    const { AuthComponent } = await import('src/app/features/auth/auth.component');
    const modelRef = this.ngbModal.open(AuthComponent, { scrollable: true, modalDialogClass: 'auth-modal' });
    modelRef.componentInstance.authModel = CommonConstants.AUTH_MODAL_TYPES.REGISTER;
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
